export function printCameraInfo(info) {
  console.debug('react-html5-camera-photo info:', info);
}
